import React, { useEffect, useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {
  SelectInputComponent,
  TextInputComponent,
} from "../../../../../common/components";
import MUITable from "../../../../../common/components/mui-table/mui-table";
import CompanyDashboardAddExistingObjectivesPopup from "../../../company-dashboard-add-existing-objectives-popup/company-dashboard-add-existing-objectives-popup";
import WarningConfirmationPopup from "../../../../../common/components/warning-confirmation-popup/warning-confirmation-popup";
import addCirculIcon from "../../../../../assets/icons/addREC.svg";
import DatePickerComponent from "../../../../../common/components/date-picker/date-picker-compoenent";
import deleteRedIcon from "../../../../../assets/icons/linkBreak.svg";
import CloseIcon from "../../../../../assets/icons/closeIcon.svg";
import { addKeyresult } from "../../../../../api/objectives";
import {
  getKeyResultById,
  updateKeyResult,
} from "../../../../../api/initiative";
import { formatKeyResultPayload } from "../../../company-dashboard-utils";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { debounce } from "lodash";
import { getKeyResultTitle } from "../../../../../api/title-search";

export interface StatusOption {
  statusId: number;
  statusName: string;
}
const CompanyDashboardAddKeyResultsPopup: any = (props: any) => {
  const {
    isOpenAddPopup,
    onCancel,
    employeesList,
    setAlertType,
    setAlertOpen,
    setLoading,
    setAlertMessage,
    objectiveId,
    setIsAccordion,
    updateInitiativeById,
    keyResultId,
    statusListObjectives,
    fetchInitiativeById,
    handleNewCreateKeyResult,
    initiativeAPIData,
    handleCreateInitiative,
    payloadData,
  } = props;
  const [KeyResultResponse, setKeyResultResponse] = useState<any>(null);
  const [isOpenAddObjectivePopup, setIsOpenAddObjectivePopup] = useState(false);
  const [isDeleteWarningOpen, setIsDeleteWarningOpen] = useState(false);
  const [isShowForm, setIsShowForm] = useState(false);
  const [selectedDeleteObjective, setSelectedDeleteObjective] =
    useState<any>(null);
  const headers = [
    { key: "title", label: "Title" },
    { key: "weightage", label: "Weightage" },
    // { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];
  const [titleSuggestions, setTitleSuggestions] = useState<any[]>([]);
  const [loadingTitles, setLoadingTitles] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [autocompleteOpen, setAutocompleteOpen] = useState(false);

  // Clear search state when popup closes
  React.useEffect(() => {
    if (!isOpenAddPopup) {
      setTitleSuggestions([]);
      setHasSearched(false);
      setAutocompleteOpen(false);
      setLoadingTitles(false);
    }
  }, [isOpenAddPopup]);

  // Debounced function to search for initiative titles
  const searchKeyResultsTitles = React.useMemo(
    () =>
      debounce(async (searchValue: string) => {
        if (!searchValue || searchValue.trim().length < 2) {
          setTitleSuggestions([]);
          setHasSearched(false);
          return;
        }

        setLoadingTitles(true);
        setHasSearched(true);
        try {
          const response = await getKeyResultTitle({ title: searchValue });
          const keyresults = response?.data?.data || [];
          setTitleSuggestions(keyresults);
        } catch (error: any) {
          console.error("Error fetching key result titles:", error);
          setTitleSuggestions([]);
        } finally {
          setLoadingTitles(false);
        }
      }, 500),
    [],
  );

  const handleCloseAddObjectivePopup = () => {
    setIsOpenAddObjectivePopup(false);
  };
  const handleOpenAddObjectivePopup = () => {
    setIsOpenAddObjectivePopup(true);
  };

  const getStatusFormattedData = (
    statusName: any,
    setFieldValue: any,
    data: any,
    item: any,
  ) => {
    return (
      <div className="form-group form-group-status form-text-input-component">
        <Autocomplete<StatusOption>
          value={statusName}
          onChange={(event, newValue) => {
            setFieldValue(
              "selectedObjectiveData",
              data.map((obj: any) =>
                obj.objectiveId === item.objectiveId
                  ? { ...obj, status: newValue }
                  : obj,
              ),
            );
          }}
          options={statusListObjectives || []}
          getOptionLabel={(option) => option.statusName}
          isOptionEqualToValue={(option, value) =>
            option.statusId === value.statusId
          }
          renderInput={(params) => <TextField {...params} label="" />}
        />
      </div>
    );
  };

  const getWeightageFormattedData = (
    weightage: any,
    setFieldValue: any,
    data: any,
    item: any,
  ) => {
    return (
      <div className="form-group form-group-section-four-column">
        <TextInputComponent
          type="text"
          fieldName="weightage"
          placeholder="0.00"
          value={item?.weightage ? `${item.weightage}` : ""}
          isLocked={true}
          lockedIcons={
            <i
              className="fa fa-percent"
              style={{ color: "#0000008a", fontWeight: "normal" }}
            />
          }
          onChange={(e: any) => {
            if (e?.target?.value === "" || /^\d+$/.test(e?.target?.value)) {
              setFieldValue(
                "selectedObjectiveData",
                data.map((obj: any) =>
                  obj.objectiveId === item.objectiveId
                    ? { ...obj, weightage: e?.target?.value }
                    : obj,
                ),
              );
            }
          }}
        />
      </div>
    );
  };

  const getActionsFormattedData = (
    item: any,
    setFieldValue: any,
    data: any,
    formValues: any,
  ) => {
    return (
      <button
        type="button"
        style={{
          border: "none",
          background: "none",
          padding: 0,
          cursor: item?.isShowDelete ? "not-allowed" : "pointer",
        }}
        onClick={() => {
          if (data?.length > 1) {
            const updatedData = data.filter(
              (obj: any) => obj.objectiveId !== item.objectiveId,
            );
            const deletedObjective = KeyResultResponse?.objectives?.find(
              (obj: any) => obj.objectiveId === item?.objectiveId,
            );
            if (deletedObjective) {
              const isAlreadyDeleted = formValues?.deletedObjectiveData?.find(
                (obj: any) => obj.objectiveId === deletedObjective.objectiveId,
              );
              if (!isAlreadyDeleted) {
                setFieldValue("deletedObjectiveData", [
                  ...(formValues?.deletedObjectiveData || []),
                  deletedObjective,
                ]);
              }
            }
            setFieldValue("selectedObjectiveData", updatedData);
          } else {
            setIsDeleteWarningOpen(true);
            setSelectedDeleteObjective(item);
          }
        }}
      >
        <img src={deleteRedIcon} alt="close" className="close-icon" />
      </button>
    );
  };

  const formattedData = (data: any, setFieldValue: any, formValues: any) => {
    if (Array.isArray(data) && data.length > 0) {
      return data.map((item: any) => {
        const statusForItem = statusListObjectives.find(
          (status: any) => status.statusName === item?.status?.statusName,
        );

        if (!statusForItem) {
          item.status = { statusId: 3, statusName: "Not Started" };
        }

        return {
          id: item.objectiveId,
          title: item?.objectiveName || "-",
          status: getStatusFormattedData(
            item?.status,
            setFieldValue,
            data,
            item,
          ),
          weightage: getWeightageFormattedData(
            item?.weightage,
            setFieldValue,
            data,
            item,
          ),
          actions: getActionsFormattedData(
            item,
            setFieldValue,
            data,
            formValues,
          ),
          data: item,
        };
      });
    }
    return [];
  };

  const validationSchema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    owner: Yup.array().min(1, "Owner is required"),
    startDate: Yup.date().required("Start Date is required"),
    endDate: Yup.date()
      .min(Yup.ref("startDate"), "End Date cannot be before Start Date")
      .required("End Date is required"),
    weightage: Yup.number()
      .typeError("Weightage must be a number")
      .min(0, "Weightage cannot be negative")
      .max(100, "Weightage cannot exceed 100"),
    selectedObjectiveData: Yup.array().min(
      1,
      "At least one linked objective is required",
    ),
  });

  const handleCreateObjectiveKeyResult = async (formValues: any) => {
    setLoading(true);
    try {
      const payload = formatKeyResultPayload(
        formValues,
        { pk: objectiveId },
        keyResultId,
        KeyResultResponse?.owners?.length > 0
          ? KeyResultResponse?.owners?.map(
              (owner: any) =>
                employeesList?.find(
                  (emp: any) => emp.employeeId === owner.employeeId,
                )?.employeeId || null,
            )
          : [],
      );

      const response: any = keyResultId
        ? await updateKeyResult(keyResultId, payload)
        : await addKeyresult(payload);
      if (!initiativeAPIData?.title) {
        handleNewCreateKeyResult([{ keyResultId: response?.data?.data?.pk }]);
        setIsAccordion(true);
      } else if (!keyResultId && initiativeAPIData?.id) {
        handleCreateInitiative(() => {}, {
          ...payloadData,
          objectives: [
            {
              objectiveId:
                payload?.objectives?.map((obj: any) => obj.objectiveId) || [],
              keyResultId: response?.data?.data?.pk,
              weightage: payload?.weightage || 0,
              isRemove: 0,
            },
          ],
          threshold: initiativeAPIData?.threshold,
        });
      } else if (initiativeAPIData?.id) {
        fetchInitiativeById();
      } else {
        updateInitiativeById();
        setAlertMessage("Key Result updated successfully");
      }
      setAlertType("success");
      setAlertOpen(true);
      setLoading(false);
      onCancel();
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to create Key Result",
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  const fetchKeyResultById = async () => {
    setLoading(true);
    try {
      const response = await getKeyResultById(keyResultId);
      setKeyResultResponse(response?.data?.data);
      setTimeout(() => setLoading(false), 0);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch key result",
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (keyResultId) {
      fetchKeyResultById();
    } else {
      setIsShowForm(true);
    }
  }, [keyResultId]);

  const handleSelectedObjectiveData = (
    data: any,
    setFieldValue: any,
    values: any,
  ) => {
    const existingObjectiveIds = values?.deletedObjectiveData?.filter(
      (obj: { objectiveId: number }) =>
        !data?.find(
          (d: { objectiveId: number }) => d.objectiveId === obj.objectiveId,
        )?.objectiveId,
    );
    setFieldValue("deletedObjectiveData", existingObjectiveIds);
    setFieldValue("selectedObjectiveData", data);
  };

  const handleCancelDelete = () => {
    setIsDeleteWarningOpen(false);
  };
  const handleConfirmDelete = (
    setFieldValue: any,
    data: any,
    formValues: any,
  ) => {
    const updatedData = data.filter(
      (obj: any) => obj.objectiveId !== selectedDeleteObjective.objectiveId,
    );
    const deletedObjective = KeyResultResponse?.objectives?.find(
      (obj: any) => obj.objectiveId === selectedDeleteObjective?.objectiveId,
    );
    if (deletedObjective) {
      const isAlreadyDeleted = formValues?.deletedObjectiveData?.find(
        (obj: any) => obj.objectiveId === deletedObjective.objectiveId,
      );
      if (!isAlreadyDeleted) {
        setFieldValue("deletedObjectiveData", [
          ...(formValues?.deletedObjectiveData || []),
          deletedObjective,
        ]);
      }
    }
    setFieldValue("selectedObjectiveData", updatedData);
    setIsDeleteWarningOpen(false);
    setSelectedDeleteObjective(null);
  };
  const titleTooltip = (values: any) => {
    return values.title.length < 2
      ? "Type at least 2 characters"
      : "No results found.";
  };

  const slotsPaperTile = (props: any, values: any) => {
    const showNoResults =
      !loadingTitles &&
      hasSearched &&
      titleSuggestions.length === 0 &&
      values.title.trim().length >= 2;

    const showLoading = loadingTitles;

    const renderContent = () => {
      if (showLoading) {
        return (
          <div
            style={{
              padding: "8px 16px",
              color: "#666",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            Searching...
          </div>
        );
      }
      if (showNoResults) {
        return (
          <div
            style={{
              padding: "8px 16px",
              color: "#666",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            No results found.
          </div>
        );
      }
      if (titleSuggestions.length === 0) {
        return (
          <div
            style={{
              padding: "8px 16px",
              color: "#666",
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            Search
          </div>
        );
      }
      return props.children;
    };

    return (
      <div
        {...props}
        style={{
          backgroundColor: "#fff",
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 8px",
            background: "#fff",
            borderBottom: "0.5px solid #eee",
          }}
        >
          <div className="" style={{ fontSize: "14px" }}>
            <InputLabel style={{ fontSize: "14px" }}>
              Existing Key Results
            </InputLabel>
          </div>
          <button
            style={{
              border: "none",
              background: "none",
              padding: 0,
            }}
            onClick={(e) => {
              e.stopPropagation();
              setTitleSuggestions([]);
              setHasSearched(false);
              setAutocompleteOpen(false);
            }}
          >
            <img
              alt="Close"
              src={CloseIcon}
              style={{
                cursor: "pointer",
                color: "#555",
                margin: "4px 0",
              }}
            />
          </button>
        </div>
        {renderContent()}
      </div>
    );
  };
  return (
    <Dialog
      open={isOpenAddPopup}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={`company-dashboard-add-popup-container  company-dashboard-edit-key-results-popup-container`}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return;
        }
        onCancel();
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <div className="header-wrapper">
          <div className="header-wrapper-text">
            {keyResultId ? "Edit Key Result" : "Add Key Result"}
          </div>
          <div className="image-wrapper">
            <button
              style={{
                border: "none",
                background: "none",
                padding: 0,
              }}
              onClick={onCancel}
            >
              <img
                src={CloseIcon}
                className="close-icon"
                style={{ cursor: "pointer" }}
                alt="close"
              />
            </button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        {KeyResultResponse || isShowForm ? (
          <Formik
            initialValues={{
              title: KeyResultResponse?.title || "",
              description: KeyResultResponse?.description || "",
              startDate: KeyResultResponse?.startDate
                ? dayjs(KeyResultResponse?.startDate)
                : dayjs(),
              endDate: KeyResultResponse?.endDate
                ? dayjs(KeyResultResponse?.endDate)
                : dayjs(),
              owner:
                KeyResultResponse?.owners?.length > 0
                  ? KeyResultResponse?.owners?.map(
                      (owner: any) =>
                        employeesList?.find(
                          (emp: any) => emp.employeeId === owner.employeeId,
                        )?.employeeFullName || "",
                    )
                  : [],
              weightage: KeyResultResponse?.weightage || "0.00",
              comments: KeyResultResponse?.comments || "",
              ownerId:
                KeyResultResponse?.owners?.length > 0
                  ? KeyResultResponse?.owners?.map(
                      (owner: any) =>
                        employeesList?.find(
                          (emp: any) => emp.employeeId === owner.employeeId,
                        )?.employeeId || null,
                    )
                  : [],
              selectedObjectiveData:
                KeyResultResponse?.objectives?.map((objectivesData: any) => ({
                  objectiveId: objectivesData?.objectiveId,
                  objectiveName: objectivesData?.objectiveName,
                  weightage: objectivesData?.weightage,
                })) || [],
              deletedObjectiveData: [],
            }}
            validationSchema={validationSchema}
            validateOnChange={true}
            enableReinitialize={false}
            onSubmit={(values) => {
              const newKeyResult = {
                ...values,
                // statusId,
                initiatives: [],
                isSelected: true,
              };
              handleCreateObjectiveKeyResult(newKeyResult);
            }}
          >
            {({
              values,
              setFieldValue,
              touched,
              errors,
              validateField,
              isValid,
              submitCount,
            }) => (
              <Form>
                <OverlayScrollbarsComponent
                  className="create-lead-capture-popup-confirmation-description-checkbox-input"
                  options={{
                    scrollbars: {
                      theme: "os-theme-dark",
                      autoHide: "scroll",
                      autoHideDelay: 400,
                    },
                  }}
                >
                  <div className="form-group form-text-input-component">
                    <InputLabel>Title</InputLabel>
                    <Autocomplete
                      freeSolo
                      options={titleSuggestions}
                      getOptionLabel={(option: any) =>
                        typeof option === "string" ? option : option.title || ""
                      }
                      loading={loadingTitles}
                      filterOptions={(x) => x}
                      open={autocompleteOpen}
                      onOpen={() => {
                        // Only open if there's meaningful content to show
                        if (
                          values.title.trim().length >= 2 ||
                          titleSuggestions.length > 0 ||
                          loadingTitles
                        ) {
                          setAutocompleteOpen(true);
                        }
                      }}
                      onClose={(event, reason) => {
                        // Always close on blur (clicking outside) or escape key
                        if (reason === "blur" || reason === "escape") {
                          setAutocompleteOpen(false);
                          return;
                        }

                        // For other reasons, keep open if there are results, loading, or no results after search
                        const shouldStayOpen =
                          titleSuggestions.length > 0 ||
                          loadingTitles ||
                          (hasSearched &&
                            !loadingTitles &&
                            values.title.trim().length >= 2);

                        // Only close if shouldn't stay open (not when showing no results)
                        if (!shouldStayOpen) {
                          setAutocompleteOpen(false);
                        }
                      }}
                      disableClearable
                      value={values.title}
                      inputValue={values.title}
                      onInputChange={(event, newInputValue, reason) => {
                        if (reason === "input") {
                          setFieldValue("title", newInputValue);
                          searchKeyResultsTitles(newInputValue);
                          // Open dropdown when typing with enough characters
                          if (newInputValue.trim().length >= 2) {
                            setAutocompleteOpen(true);
                          } else {
                            // Close dropdown when text is cleared or too short
                            setAutocompleteOpen(false);
                            setTitleSuggestions([]);
                            setHasSearched(false);
                          }
                        }
                      }}
                      onChange={(event) => {
                        // Prevent selection - only allow typing
                        event.preventDefault();
                      }}
                      onBlur={() => {
                        // Only clear if we're not showing no results message
                        setTimeout(() => {
                          const shouldKeepOpen =
                            titleSuggestions.length > 0 ||
                            loadingTitles ||
                            (hasSearched &&
                              !loadingTitles &&
                              values.title.trim().length >= 2);

                          if (!shouldKeepOpen) {
                            setTitleSuggestions([]);
                            setHasSearched(false);
                            setAutocompleteOpen(false);
                          }
                        }, 200);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Enter Title"
                          slotProps={{
                            htmlInput: {
                              ...params.inputProps,
                              maxLength: 150,
                            },
                          }}
                        />
                      )}
                      renderOption={(props, option: any) => (
                        <Tooltip title="Selection is turned off for this field.">
                          <li
                            {...props}
                            style={{
                              cursor: "not-allowed",
                              padding: "8px 16px",
                              opacity: 0.7,
                              backgroundColor:
                                values?.title?.trim()?.toLowerCase() ===
                                option.title?.trim()?.toLowerCase()
                                  ? "#ddddfa"
                                  : "transparent !important",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor =
                                values?.title?.trim()?.toLowerCase() ===
                                option.title?.trim()?.toLowerCase()
                                  ? "#ddddfa"
                                  : "transparent !important";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                values?.title?.trim()?.toLowerCase() ===
                                option.title?.trim()?.toLowerCase()
                                  ? "#ddddfa"
                                  : "transparent !important";
                            }}
                          >
                            <div
                              style={{
                                fontSize: "14px",
                                pointerEvents: "none",
                              }}
                            >
                              {option.title}
                            </div>
                          </li>
                        </Tooltip>
                      )}
                      noOptionsText={
                        loadingTitles ? "Searching..." : titleTooltip(values)
                      }
                      slotProps={{
                        listbox: {
                          style: {
                            maxHeight: "200px",
                          },
                        },
                      }}
                      slots={{
                        paper: (props) => slotsPaperTile(props, values),
                      }}
                    />
                    <ErrorMessage
                      name="title"
                      component="div"
                      className="error-message"
                    />
                  </div>
                  <div className="form-groups-two-column">
                    <div className="form-group form-group-section-two-column">
                      <DatePickerComponent
                        fieldName={"startDate"}
                        label="Start Date"
                        value={values?.startDate}
                        minDate={dayjs()}
                        onChange={(e: any) => {
                          setFieldValue("startDate", e);
                        }}
                      />
                    </div>
                    <div className="form-group form-group-section-two-column">
                      <DatePickerComponent
                        fieldName={"endDate"}
                        label="End Date"
                        value={values?.endDate}
                        minDate={values?.startDate || dayjs()}
                        onChange={(e: any) => {
                          setFieldValue("endDate", e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-groups-two-column">
                    <div className="form-group form-group-section-two-column">
                      <SelectInputComponent
                        fieldName="owner"
                        placeholder="Select Owner"
                        label="Owner"
                        optional={false}
                        disabled={false}
                        multiple={true}
                        isOwnerDropdown={true}
                        options={employeesList?.map((emp: any) => {
                          return {
                            value: emp.employeeFullName,
                            label: emp.employeeFullName,
                            image: emp.employeeImage || null,
                            avatar: emp.employeeImage
                              ? null
                              : emp.employeeFullName,
                          };
                        })}
                        value={values.owner}
                        onChange={(e: any) => {
                          setFieldValue("owner", e);
                          setFieldValue(
                            "ownerId",
                            e?.map(
                              (eValue: any) =>
                                employeesList?.find(
                                  (emp: any) =>// NOSONAR
                                   emp.employeeFullName === eValue,
                                )?.employeeId,
                            ),
                          );
                          // Trigger validation if form has been submitted before
                          if (touched.owner) {
                            setTimeout(() => {
                              validateField("owner");
                            }, 0);
                          }
                        }}
                      />
                      <ErrorMessage
                        name={"owner"}
                        component="div"
                        className="error-message"
                      />
                    </div>
                  </div>
                  <div className="company-dashboard-edit-key-results-object-popup-container">
                    <div className="company-dashboard-edit-key-results-object-popup-container-header">
                      <div>Linked Objectives</div>
                      <div className="company-dashboard-edit-key-results-object-popup-container-header-actions">
                        <button
                          style={{
                            border: "none",
                            background: "none",
                            padding: 0,
                          }}
                          onClick={handleOpenAddObjectivePopup}
                          type="button"
                        >
                          <img
                            src={addCirculIcon}
                            alt="key-result"
                            style={{ cursor: "pointer" }}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="company-dashboard-edit-key-results-object-list-container">
                    <div className="error-message">
                      {typeof errors?.selectedObjectiveData === "string"
                        ? errors?.selectedObjectiveData || ""
                        : null}
                    </div>
                    <MUITable
                      columnNames={headers}
                      rowsData={[
                        ...formattedData(
                          values?.selectedObjectiveData,
                          setFieldValue,
                          values,
                        ),
                      ]}
                    />
                  </div>
                </OverlayScrollbarsComponent>
                {isDeleteWarningOpen ? (
                  <WarningConfirmationPopup
                    isOpen={isDeleteWarningOpen}
                    onClose={handleCancelDelete}
                    onConfirm={() =>
                      handleConfirmDelete(
                        setFieldValue,
                        values?.selectedObjectiveData,
                        values,
                      )
                    }
                    title="De-link Objective"
                    description="You’re about to remove the last linked objective. Are you sure you want to delink it?"
                    confirmButtonText="Delink"
                    cancelButtonText="Cancel"
                  />
                ) : (
                  ""
                )}
                {isOpenAddObjectivePopup ? (
                  <CompanyDashboardAddExistingObjectivesPopup
                    isOpenAddPopup={isOpenAddObjectivePopup}
                    onCancel={handleCloseAddObjectivePopup}
                    setLoading={setLoading}
                    setSelectedObjectiveData={(data: any) => {
                      handleSelectedObjectiveData(data, setFieldValue, values);
                    }}
                    selectedObjectiveData={values?.selectedObjectiveData}
                  />
                ) : (
                  ""
                )}

                <DialogActions>
                  <div className="action-btn-wrapper">
                    <button
                      onClick={onCancel}
                      type="button"
                      className="cancel-btn"
                    >
                      Cancel
                    </button>
                    {submitCount > 0 && !isValid ? (
                      <Tooltip
                        title="Please resolve all errors before submitting."
                        placement="top"
                      >
                        <span>
                          <button
                            type="submit"
                            autoFocus
                            className="action-btn"
                            disabled
                            style={{
                              opacity: 0.5,
                              cursor: "not-allowed",
                            }}
                          >
                            {keyResultId ? "Save" : "Add"}
                          </button>
                        </span>
                      </Tooltip>
                    ) : (
                      <button
                        type="submit"
                        autoFocus
                        className="action-btn"
                        style={{
                          opacity: 1,
                          cursor: "pointer",
                        }}
                      >
                        {keyResultId ? "Save" : "Add"}
                      </button>
                    )}
                  </div>
                </DialogActions>
              </Form>
            )}
          </Formik>
        ) : (
          ""
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CompanyDashboardAddKeyResultsPopup;
